// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_2129aa","pricingRow":"_4b5ef2","divider":"_c9491a","pricingList":"_c08ff6","bold":"_dffeeb","pricingButton":"_e2d586"};